import type { ProPlanKey } from 'src/components/buyCreditsDialog/benefits';

/** A job seeker's problem the pass answers. Openers pick the one closest to
 * what the candidate was doing, and the pitch leads with it. */
export type ProNeed = 'callbacks' | 'ats' | 'guidance' | 'hidden' | 'skills';

/** The plan item (benefits.ts PRO_PLAN) whose row the pitch leads with. Both
 * resume needs are walls on AI credits: scoring and tailoring spend them. */
export const NEED_PLAN_KEY: Record<ProNeed, ProPlanKey> = {
  callbacks: 'ai',
  ats: 'ai',
  guidance: 'guidance',
  hidden: 'hidden',
  skills: 'courses',
};
